module.exports = __webpack_public_path__ + "img/tdt-bg.cc259084.png";